import find from "lodash/find";
import map from "lodash/map";
import { Inline, Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { ClosureReason, Profile, Vacancy } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "./vacancy.module.scss";

export type ClosedVacancyProps = {
  closureDetails: string;
  filledRole?: Vacancy;
  profiles?: Profile[];
  closureReasons: ClosureReason[];
};

export const ClosedVacancy = ({
  closureDetails,
  profiles,
  filledRole,
  closureReasons
}: ClosedVacancyProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.vacancies" });

  const filledWith = find(closureReasons, ["key", filledRole?.closureReason])?.label;
  const filledProfiles = map(profiles, getProfileName).join(", ");

  return (
    <Inline>
      <Stack className={css.columnItem}>
        <Typography variant="labelRegular">{t("selectClosureReason")}</Typography>
        <Typography variant="bodyBold">{filledWith}</Typography>
      </Stack>
      {closureDetails && (
        <Stack className={css.columnItem}>
          <Typography variant="labelRegular">{t("details")}</Typography>
          <Typography variant="bodyBold">{closureDetails}</Typography>
        </Stack>
      )}
      {filledProfiles && (
        <Stack className={css.columnItem}>
          <Typography variant="labelRegular">{t("workforceMember")}</Typography>
          <Typography variant="bodyBold">{filledProfiles}</Typography>
        </Stack>
      )}
    </Inline>
  );
};
